import { decodeBase64UrlToString } from './decodeBase64UrlToString.js';
import { toSafeString } from './toSafeString.js';

export const decodeJwtPayload = (token) => {
  const normalizedToken = toSafeString(token);

  if (!normalizedToken || !normalizedToken.includes('.')) {
    return null;
  }

  const payloadPart = normalizedToken.split('.')[1] || '';

  if (!payloadPart) {
    return null;
  }

  try {
    const decodedPayload = decodeBase64UrlToString(payloadPart);
    return JSON.parse(decodedPayload);
  } catch {
    return null;
  }
};
